export const cruisingLocationCodes = ['ASE', 'CRU', 'XID'];